export class Config {
    static MODULENAME = 'Tracing';
}
